import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltung-aktion-reihenfolge-setzen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungAktionReihenfolgeSetzenEffects {

    VeranstaltungAktionReihenfolgeSetzen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_VERANSTALTUNG_AKTION_REIHENFOLGE_SETZEN),
        mergeMap((x: ac.PostVeranstaltungAktionReihenfolgeSetzenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postVeranstaltungAktionReihenfolgeSetzen(x.aktionReihenfolgeSetzenMultiRequest).pipe(
                map((result: any) => {
                    return new ac.PostVeranstaltungAktionReihenfolgeSetzenErfolgreichAction(result, x.aktionReihenfolgeSetzenMultiRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostVeranstaltungAktionReihenfolgeSetzenFehlerAction(error, x.aktionReihenfolgeSetzenMultiRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
